import { Fragment, useEffect } from "react";
import { useAppSelector } from "hooks";
import { selectPopUpManagerV2State } from "redux/slices/pop-up-manager-v2";
import { ManagedPopUp } from "redux/slices/pop-up-manager-v2/types";
import PopUpShell from "./PopUpShell";

const PopUpManagerV2: React.FC = () => {
	const { stack } = useAppSelector(selectPopUpManagerV2State);

	// Lock body scroll while any V2 popup is open
	useEffect(() => {
		if (typeof document === "undefined") {
			return;
		}
		const body = document.body;
		body.style.overflow = stack.length > 0 ? "hidden" : "";
		return () => {
			body.style.overflow = "";
		};
	}, [stack.length]);

	if (!stack.length) {
		return null;
	}
	return (
		<Fragment>
			{stack.map((popup: ManagedPopUp, i: number) => (
				<PopUpShell
					key={popup.id}
					popup={popup}
					index={i}
					isTop={i === stack.length - 1}
				/>
			))}
		</Fragment>
	);
};

export default PopUpManagerV2;
